/**
 * @readonly
 * @enum {string}
 */
module.exports = {
    SUPERADMIN: 'superadmin',
    MANAGER: 'manager',
    OFFICIAL: 'official',
};
